import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { extensionDecorator, PlainExtension, isFunction, environment, nonChainable } from '@remirror/core';
import { redo, undo, history } from '@remirror/pm/history';

var _dec, _class, _temp;
var HistoryExtension = (_dec = /*#__PURE__*/extensionDecorator({
  defaultOptions: {
    depth: 100,
    newGroupDelay: 500,
    getDispatch: undefined,
    getState: undefined
  },
  staticKeys: ['depth', 'newGroupDelay'],
  handlerKeys: ['onRedo', 'onUndo']
}), /*#__PURE__*/_dec(_class = (_temp = class HistoryExtension extends PlainExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "wrapMethod", (method, callback) => {
      return (_ref) => {
        var state = _ref.state,
            dispatch = _ref.dispatch,
            view = _ref.view;
        var _this$options = this.options,
            getState = _this$options.getState,
            getDispatch = _this$options.getDispatch;
        var wrappedState = isFunction(getState) ? getState() : state;
        var wrappedDispatch = isFunction(getDispatch) && dispatch ? getDispatch() : dispatch;
        var success = method(wrappedState, wrappedDispatch, view);
        callback === null || callback === void 0 ? void 0 : callback(success);
        return success;
      };
    });
  }

  get name() {
    return 'history';
  }
  /**
   * Wraps the history method to inject state from the getState or getDispatch
   * method.
   *
   * @param method - the method to wrap
   */


  /**
   * Adds the default key mappings for undo and redo.
   */
  createKeymap() {
    var notMacOS = !environment.isMac ? {
      ['Mod-y']: this.wrapMethod(redo, this.options.onRedo)
    } : undefined;
    return _objectSpread({
      'Mod-y': () => false,
      'Mod-z': this.wrapMethod(undo, this.options.onUndo),
      'Shift-Mod-z': this.wrapMethod(redo, this.options.onRedo)
    }, notMacOS);
  }
  /**
   * Bring the `prosemirror-history` plugin with options set on this extension.
   */


  createExternalPlugins() {
    var _this$options2 = this.options,
        depth = _this$options2.depth,
        newGroupDelay = _this$options2.newGroupDelay;
    return [history({
      depth,
      newGroupDelay
    })];
  }
  /**
   * Provide the undo and redo commands.
   */


  createCommands() {
    return {
      /**
       * Undo the last action that occurred. This can be overridden by
       * setting an `"addToHistory"` metadata property of `false` on a
       * transaction to prevent it from being rolled back by undo.
       *
       * ```ts
       * actions.undo()
       *
       * // To prevent this use
       * tr.setMeta(pluginKey, { addToHistory: false })
       * ```
       *
       * This command is **non-chainable**.
       */
      undo: () => nonChainable(this.wrapMethod(undo, this.options.onUndo)),

      /**
       * Redo an action that was in the undo stack.
       *
       * ```ts
       * actions.redo()
       * ```
       *
       * This command is **non-chainable**.
       */
      redo: () => nonChainable(this.wrapMethod(redo, this.options.onRedo))
    };
  }

}, _temp)) || _class);

export { HistoryExtension };
